module.exports = __webpack_public_path__ + "static/index/img/baikal-411.e9bed69f.jpg";